// Chakra Imports
import {
  Avatar,
  Button,
  Flex,
  Icon,
  Image,
  Link,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';
import { getCookie, deleteCookie } from 'cookies-next';
// Custom Components
import { ItemContent } from 'components/menu/ItemContent';
import { SearchBar } from 'components/navbar/searchBar/SearchBar';
import { SidebarResponsive } from 'components/sidebar/Sidebar';
// Assets
import navImage from 'assets/img/layout/Navbar.png';
import { MdNotificationsNone, MdInfoOutline, MdFeedback, MdHelp, MdLogout, MdPerson3, MdMenu, MdMenuOpen } from 'react-icons/md';
import { FaEthereum } from 'react-icons/fa';
import { logoutUser } from '../../redux/slices/authSlice';

import Configurator from 'components/navbar/Configurator';
import routes from 'routes';
// import { Router } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useJwt } from 'react-jwt';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import PerfilUsuarioModal from '../../views/Perfil/Perfil';
import axiosInstance from 'api/AxiosInstance';
import AyudaUsuario from 'views/Perfil/Ayuda';
import ModalQuejasSugerencias from 'views/Perfil/Quejas';

export default function HeaderLinks(props: {
  secondary: boolean;
  [x: string]: any;
}) {
  const { secondary, theme, setTheme } = props;
  const user = useSelector((state: RootState) => state.auth.user);
  const token = getCookie('token');
  const jwt = useJwt(token);
  const dispatch = useDispatch();
  const [perfil, setPerfil] = useState<any | null>(null);
  const [ayuda, setAyuda] = useState<any | null>(null);


  const [isPerfilOpen, setPerfilOpen] = useState(false);

  const [isAyudaOpen, setAyudaOpen] = useState(false);
  const [isQueja, setQuejaOpen] = useState(false);

const openPerfil = () => setPerfilOpen(true);
const closePerfil = () => setPerfilOpen(false);

const openAyuda = () => setAyudaOpen(true);
const closeAyuda = () => setAyudaOpen(false);

const openQueja = () => setQuejaOpen(true);
const closeQueja = () => setQuejaOpen(false);


  const [valoresxz, setvaloresx] = useState({ nombre: '', imagen: '' });
  let [NC, setNC] = useState('');
  let [Imagen, setImagen] = useState('');
  let valores = JSON.stringify(jwt.decodedToken);
  let valoresx = JSON.parse(valores);
  // Chakra Color Mode
  const x = useNavigate();
  const navbarIcon = useColorModeValue('gray.400', 'white');
  let menuBg = useColorModeValue('white', 'navy.800');
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const textColorBrand = useColorModeValue('brand.700', 'brand.400');
  const ethColor = useColorModeValue('gray.700', 'white');
  const borderColor = useColorModeValue('#E6ECFA', 'rgba(135, 140, 189, 0.3)');
  const ethBg = useColorModeValue('secondaryGray.300', 'navy.900');
  const ethBox = useColorModeValue('white', 'navy.800');
  const shadow = useColorModeValue(
    '14px 17px 40px 4px rgba(112, 144, 176, 0.18)',
    '14px 17px 40px 4px rgba(112, 144, 176, 0.06)',
  );
  const borderButton = useColorModeValue('secondaryGray.500', 'whiteAlpha.200');
  useEffect(() => {
    //
    fetchData();
  },[]);

  const fetchData = async () => {
    try {

                const res = await axiosInstance.get('/usuario/perfil/'+user?.id); // no uses /api si ya lo tienes en baseURL
                setImagen(res.data.imagen || '');
                setPerfil(res.data);

      // valores = JSON.stringify(jwt.decodedToken);
      // valoresx = await JSON.parse(valores);
      // setNC(valoresx.nombre);
      // setImagen(valoresx.imagen);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  return (
    <Flex
      w={{ sm: '100%', md: 'auto' }}
      alignItems="center"
      flexDirection="row"
      bg={menuBg}
      flexWrap={secondary ? { base: 'wrap', md: 'nowrap' } : 'unset'}
      p="10px"
      borderRadius="999px"
      boxShadow={shadow}
    >
      {/* <SearchBar
        mb={() => {
          if (secondary) {
            return { base: '10px', md: 'unset' };
          }
          return 'unset';
        }}
        me="10px"
        borderRadius="20px"
      /> */}
      <Flex
        bg={ethBg}
        display={secondary ? 'flex' : 'none'}
        borderRadius="20px"
        ms="auto"
        p="6px"
        align="center"
        me="6px"
      >
        <Flex
          align="center"
          justify="center"
          bg={ethBox}
          h="29px"
          w="29px"
          borderRadius="20px"
          me="7px"
        >
          <Icon color={ethColor} w="9px" h="14px" as={FaEthereum} />
        </Flex>
        <Text
          w="max-content"
          color={ethColor}
          fontSize="sm"
          fontWeight="700"
          me="6px"
        >
          Administrador
          <Text as="span" display={{ base: 'none', md: 'unset' }}>
            {' '}
            TLX
          </Text>
        </Text>
      </Flex>
      <SidebarResponsive routes={routes} />
      {/* <Menu>
        <MenuButton p="0px">
          <Icon
            mt="6px"
            as={MdNotificationsNone}
            color={navbarIcon}
            w="18px"
            h="18px"
            me="10px"
          />
        </MenuButton>
        <MenuList
          boxShadow={shadow}
          p="20px"
          borderRadius="20px"
          bg={menuBg}
          border="none"
          mt="22px"
          me={{ base: '30px', md: 'unset' }}
          minW={{ base: 'unset', md: '400px', xl: '450px' }}
          maxW={{ base: '360px', md: 'unset' }}
        >
          <Flex w="100%" mb="20px">
            <Text fontSize="md" fontWeight="600" color={textColor}>
              Notifications
            </Text>
            <Text
              fontSize="sm"
              fontWeight="500"
              color={textColorBrand}
              ms="auto"
              cursor="pointer"
            >
              Mark all read
            </Text>
          </Flex>
          <Flex flexDirection="column">
            <MenuItem
              _hover={{ bg: 'none' }}
              _focus={{ bg: 'none' }}
              px="0"
              borderRadius="8px"
              mb="10px"
            >
              <ItemContent info="Horizon UI Dashboard PRO" />
            </MenuItem>
            <MenuItem
              _hover={{ bg: 'none' }}
              _focus={{ bg: 'none' }}
              px="0"
              borderRadius="8px"
              mb="10px"
            >
              <ItemContent info="Horizon Design System Free" />
            </MenuItem>
          </Flex>
        </MenuList>
      </Menu>

      <Menu>
        <MenuButton p="0px">
          <Icon
            mt="6px"
            as={MdInfoOutline}
            color={navbarIcon}
            w="18px"
            h="18px"
            me="10px"
          />
        </MenuButton>
        <MenuList
          boxShadow={shadow}
          p="20px"
          me={{ base: '30px', md: 'unset' }}
          borderRadius="20px"
          bg={menuBg}
          border="none"
          mt="22px"
          minW={{ base: 'unset' }}
          maxW={{ base: '360px', md: 'unset' }}
        >
          <Image src={navImage} borderRadius="16px" mb="28px" />
          <Flex flexDirection="column">
            <Link w="100%" href="https://horizon-ui.com/pro">
              <Button w="100%" h="44px" mb="10px" variant="brand">
                Buy Horizon UI PRO
              </Button>
            </Link>
            <Link
              w="100%"
              href="https://horizon-ui.com/documentation/docs/introduction"
            >
              <Button
                w="100%"
                h="44px"
                mb="10px"
                border="1px solid"
                bg="transparent"
                borderColor={borderButton}
              >
                See Documentation
              </Button>
            </Link>
            <Link
              w="100%"
              href="https://github.com/horizon-ui/horizon-ui-chakra-ts"
            >
              <Button
                w="100%"
                h="44px"
                variant="no-hover"
                color={textColor}
                bg="transparent"
              >
                Try Horizon Free
              </Button>
            </Link>
          </Flex>
        </MenuList>
      </Menu>
      <Configurator
        mini={props.mini}
        setMini={props.setMini}
        theme={theme}
        setTheme={setTheme}
      /> */}

      <Menu>
        <MenuButton p="0px">
          <Avatar
            _hover={{ cursor: 'pointer' }}
            color="white"
            name={NC}
            src={Imagen}
            bg="#A1263D !important"
            size="sm"
            w="50px"
            h="50px"
            sx={{
              bg: '#A1263D !important',
              '&[data-loaded="false"]': {
                bg: '#A1263D !important'
              }
            }}
          />
        </MenuButton>
        <MenuList
          boxShadow={shadow}
          p="0px"
          mt="10px"
          borderRadius="20px"
          bg={menuBg}
          border="none"
        >
          <Flex w="100%" mb="0px">
            <Text
              ps="20px"
              pt="16px"
              pb="10px"
              w="100%"
              borderBottom="1px solid"
              borderColor={borderColor}
              fontSize="sm"
              fontWeight="700"
              color={textColor}
            >
              {user ? (
                <p>👋&nbsp; Hola, {perfil?.nombre}</p>
              ) : (
                <p>No hay usuario autenticado</p>
              )}{' '}
            </Text>
          </Flex>
          <Flex flexDirection="column" p="10px">
          <MenuItem
  _hover={{ bg: 'none' }}
  _focus={{ bg: 'none' }}
  borderRadius="8px"
  px="14px"
  onClick={openPerfil}
  icon={<MdPerson3 fontSize="18px" />}

>
  <Text fontSize="sm">Mi Perfil</Text>
</MenuItem>

<MenuItem
  _hover={{ bg: 'none' }}
  _focus={{ bg: 'none' }}
  borderRadius="8px"
  px="14px"
  onClick={openQueja}
  icon={<MdFeedback fontSize="18px" />}

>
  <Text fontSize="sm">Quejas & Sugerencias</Text>
</MenuItem>


<MenuItem
  _hover={{ bg: 'none' }}
  _focus={{ bg: 'none' }}
  borderRadius="8px"
  px="14px"
  onClick={openAyuda}
  icon={<MdHelp fontSize="18px" />}

>
  <Text fontSize="sm">Ayuda</Text>
</MenuItem>

            {/*
            <MenuItem
              _hover={{ bg: 'none' }}
              _focus={{ bg: 'none' }}
              borderRadius="8px"
              px="14px"
            >
              <Text fontSize="sm">Newsletter Settings</Text>
            </MenuItem> */}
            <MenuItem
              _hover={{ bg: 'none' }}
              _focus={{ bg: 'none' }}
              color="red"
              borderRadius="8px"
              px="14px"
              onClick={() => {
                dispatch(logoutUser());

                deleteCookie('sesion_t');
                x('/admin');
                window.location.reload();
              }}

              icon={<MdLogout fontSize="18px" />}

            >
              <Text fontSize="sm">Cerrar Sesion</Text>
            </MenuItem>
          </Flex>
        </MenuList>
      </Menu>
      <PerfilUsuarioModal isOpen={isPerfilOpen} onClose={closePerfil} />
              <AyudaUsuario isOpen={isAyudaOpen} onClose={closeAyuda}></AyudaUsuario>

<ModalQuejasSugerencias isOpen={isQueja} onClose={closeQueja}></ModalQuejasSugerencias>
    </Flex>
    
  );
}
